import * as z from 'zod';
export const LlmStreamMetadataSchema = z.object({
    actualModel: z.string().optional(),
    chatId: z.string().optional(),
    finishReason: z.string().optional(),
    logId: z.string().optional(),
    requestedModel: z.string(),
    status: z.enum(['loading', 'completed']),
    totalTokens: z.number().optional(),
});
